import fetch from '../../../utils/fetch';
import {
    PAIR_TOKEN_GET_RESET,
    PAIR_TOKEN_GET_SUCCESS,
    PAIR_TOKEN_ADD_SUCCESS,
    PAIR_TOKEN_SET_METHOD,
} from './mutation-types';
import {
    CONTACT,
    CURRENT_CONTACT_TOKEN,
    CURRENT_CONTACT_TOKEN_FORCED,
    REMOVE_CONTACT,
    SEND_TOKEN_BY_EMAIL,
} from '../../../constants/api-routes';

const getDefaultState = () => {
    return {
        loading: false,
        error: null,
        addError: null,
        token: null,
        expiration: null,
        method: null,
        addedContact: {},
    };
};
const state = getDefaultState();

function success(data) {
    return {type: PAIR_TOKEN_GET_SUCCESS, data};
}

function reset() {
    return {type: PAIR_TOKEN_GET_RESET};
}

function addSuccess(data) {
    return {type: PAIR_TOKEN_ADD_SUCCESS, data};
}

function setMethod(method) {
    return {type: PAIR_TOKEN_SET_METHOD, method};
}

const getters = {
    token: state => state.token,
    expiration: state => state.expiration,
    addedContact: state => state.addedContact,
    method: state => state.method,
};

const actions = {
    getToken({commit}, force = false) {
        let url = CURRENT_CONTACT_TOKEN;
        if (force) {
            url = CURRENT_CONTACT_TOKEN_FORCED;
        }
        return fetch(url)
            .then(data => {
                commit(success(data));
            });
    },
    sendEmail({commit}, {token, uri, email}) {
        let formData = new FormData();
        formData.set('email', email);
        formData.set('uri', uri);
        formData.set('token', token);
        return fetch(SEND_TOKEN_BY_EMAIL,
            {
                method: 'POST',
                data: formData,
            });
    },
    useToken({commit}, token) {
        return fetch(CONTACT + token, {method: 'PUT'})
            .then(data => {
                commit(addSuccess(data));
            });
    },
    remove({commit}, id) {
        return fetch(REMOVE_CONTACT + id, {method: 'PUT'})
            .catch(e => {
                return Promise.reject(e)
            });
    },
    hideModal({commit}) {
        commit(modalHide())
    },
    showModal({commit}) {
        commit(modalShow())
    },
    reset({commit}) {
        commit(reset())
    },
    setMethod({commit}, method) {
        commit(setMethod(method))
    },
};

const mutations = {
    [PAIR_TOKEN_GET_SUCCESS](state, {data}) {
        state.token = data.token;
        state.expiration = data.expiration;
    },
    [PAIR_TOKEN_GET_RESET](state) {
        Object.assign(state, getDefaultState());
    },
    [PAIR_TOKEN_ADD_SUCCESS](state, {data}) {
        state.addedContact = data;
    },
    [PAIR_TOKEN_SET_METHOD](state, {method}) {
        state.method = method;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/pair.js